import { makeStyles } from "tss-react/mui";
import { constants } from "../../constants";

interface IStyles {
    backgroundImage?: string;
}
export const useStyles = makeStyles<IStyles>()(
    (theme, { backgroundImage }) => ({
        root: {
            display: "flex",
            width: "100%",
            alignSelf: "center",
            height: "316px",
            backgroundColor: constants.color.white,
            justifyContent: "center",
        },

        container: {
            display: "block",
            width: "100%",
            maxWidth: "1148px",
            height: "100%",
            background: "transparent",
            color: constants.color.white,
            justifyContent: "center",
            flexDirection: "column",
            alignItems: "flex-start",
            position: "relative",
            zIndex: 1,
        },

        heading: {
            marginTop: "17px",
            marginBottom: "18px",
            display: "inline-flex",
            fontFamily: "Gotham Book",
            fontSize: "12px",
            fontWeight: 450,
            lineHeight: "20px",
            letterSpacing: "1.5px",
            textAlign: "left",
            color: constants.color.grey20,
            textTransform: "uppercase",
            position: "relative",
            zIndex: 1,
        },

        cardContainer: {
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
        },
    })
);
